import { useEffect, useRef } from "react";
import { useStoreLocation } from "../context/StoreLocation";
import { useAuthState } from "../context/UserAuthentication";
import { guestLogin } from "../context/UserAuthentication/actions";
import { getVisitorId } from "../helpers/helperMethods";
import useFavorites from "../react-query-hooks/useFavorites";
import { resetCheckoutPayments } from "../redux/slices/checkoutSlice";
import { useAppDispatch } from "../redux/store/store";

const UserDataController = () => {
    const { authInfo, dispatch: authDispatch } = useAuthState();
    const { locationInfo } = useStoreLocation();
    const location_id = locationInfo.selectedStore?.id;
    const dispatch = useAppDispatch();
    const isCreatingGuest = useRef(false);
    // Seed with the current id so the first effect run does not treat hydrate as a change.
    const previousUserIdRef = useRef(authInfo?.userId);

    useFavorites(authInfo?.userId, authInfo?.type, location_id);

    useEffect(() => {
        if (authInfo.userId || isCreatingGuest.current) return;
        isCreatingGuest.current = true;
        guestLogin(authDispatch, dispatch, { visitor_id: getVisitorId() })
            .finally(() => { isCreatingGuest.current = false; });
    }, [authInfo.userId]);

    // Drop persisted/selected credit cards + gift cards whenever the auth user changes
    // (guest ↔ loyalty, account switch, etc.) so one user's methods aren't reused.
    useEffect(() => {
        const previousUserId = previousUserIdRef.current;
        const currentUserId = authInfo?.userId;
        if (previousUserId !== currentUserId) {
            dispatch(resetCheckoutPayments());
            previousUserIdRef.current = currentUserId;
        }
    }, [authInfo?.userId, dispatch]);

    return null;
};

export default UserDataController;
